import { Button, ButtonVariant } from "@blueprintjs/core"
import { __ } from "src/libs/utilities"
import __Library from "../../assets/img/library.svg"
import { MouseEvent } from "react"

/* Protopia Ecosystem component */
export interface IPresetLibProps {
   title: string
   onOpen?: () => void
   onMouseOver: () => void
}
const PresetLib = (props: IPresetLibProps): JSX.Element => {
    return <div className='pe-preset-lib pe-surface-none'>
        <Button variant={ButtonVariant.MINIMAL} 
            onClick={props.onOpen} 
            onMouseOver={ (evt: MouseEvent) => {
            props.onMouseOver()
            evt.stopPropagation()
            evt.preventDefault()
        }}>
            <div className="small" >
                <div className="smaller text-uppercase letter-spacing-1 hover-border">{__("Library")}</div>
                {/* <img src={__Library} alt="" height={18} /> */}
            </div>
        </Button>
    </div>
}
export default PresetLib